module.exports = __webpack_public_path__ + "img/test-bg.daa11eea.jpg";